export default [
  {
    path: '/kompack-data-mitra-gudang',
    name: 'kompack-data-mitra-gudang',
    component: () => import('@/views/pages/kompack/mitragudang/List'),
    meta: {
      resource: 'Kompack - Mitra Gudang',
      action: 'manage',
    },
  },
  {
    path: '/kompack-tambah-list-data-mitra-gudang',
    name: 'kompack-tambah-list-data-mitra-gudang',
    component: () => import('@/views/pages/kompack/mitragudang/tambahlistdatamitragudang'),
    meta: {
      navActiveLink: 'kompack-data-mitra-gudang',
      resource: 'Kompack - Mitra Gudang',
      action: 'manage',
    },
  },
  {
    path: '/kompack-rincian-mitra-gudang/:id',
    name: 'kompack-rincian-mitra-gudang',
    component: () => import('@/views/pages/kompack/mitragudang/rincianmitragudang'),
    meta: {
      navActiveLink: 'kompack-data-mitra-gudang',
      resource: 'Kompack - Mitra Gudang',
      action: 'manage',
    },
  },
  {
    path: '/kompack-rincian-mitra-gudang/:id/information',
    name: 'kompack-rincian-mitra-gudang-information',
    component: () => import('@/views/pages/kompack/mitragudang/rincianinfomitragudang'),
    meta: {
      navActiveLink: 'kompack-data-mitra-gudang',
      resource: 'Kompack - Mitra Gudang',
      action: 'manage',
    },
  },
  {
    path: '/kompack-performa-mitra-gudang',
    name: 'kompack-performa-mitra-gudang',
    component: () => import('@/views/pages/kompack/mitragudang/performa-mitra/PerformaMitra.vue'),
    meta: {
      resource: 'Kompack - Mitra Gudang',
      action: 'manage',
    },
  },
  {
    path: '/kompack-daftar-partner',
    name: 'kompack-daftar-partner',
    component: () => import('@/views/pages/kompack/partner/PartnerList.vue'),
    meta: {
      resource: 'Kompack - Partner',
      action: 'manage',
    },
  },
  {
    path: '/kompack-request-packing',
    name: 'kompack-request-packing',
    component: () => import('@/views/pages/kompack/dashboard/request-packing/RequestPacking.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack - Fulfillment',
      action: 'manage',
    },
  },
  {
    path: '/kompack-pengajuan-barang-rusak',
    name: 'kompack-pengajuan-barang-rusak',
    component: () => import('@/views/pages/kompack/dashboard/pengajuan-barang-rusak/PengajuanBarangRusak.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack - Fulfillment',
      action: 'manage',
    },
  },
  {
    path: '/kompack-request-penarikan-barang',
    name: 'kompack-request-penarikan-barang',
    component: () => import('@/views/pages/kompack/dashboard/request-penarikan-barang/RequestPenarikanBarang.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack - Fulfillment',
      action: 'manage',
    },
  },
  {
    path: '/kompack-partner-low-moving-stock',
    name: 'kompack-partner-low-moving-stock',
    component: () => import('@/views/pages/kompack/dashboard/partner-low-moving-stock/PartnerLowMovingStock.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack - Fulfillment',
      action: 'manage',
    },
  },
  {
    path: '/kompack/tagihan',
    name: 'kompack-tagihan',
    component: () => import('@/views/pages/kompack/dashboard/tagihan/Tagihan.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack - Fulfillment',
      action: 'manage',
    },
  },
  {
    path: '/kompack/total-nilai-transaksi',
    name: 'kompack-total-nilai-transaksi',
    component: () => import('@/views/pages/kompack/dashboard/total-nilai-transaksi/TotalNilaiTransaksi.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack - Dashboard',
      action: 'manage',
    },
  },
  {
    path: '/kompack/total-nilai-transaksi/fulfillment/komship/:id',
    name: 'kompack-total-nilai-transaksi-fulfillment-komship-detail',
    component: () => import('@/views/pages/kompack/dashboard/total-nilai-transaksi/fulfillment/komship/FulfillmentKomshipDetail.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack - Dashboard',
      action: 'manage',
    },
  },
  {
    path: '/kompack/total-nilai-transaksi/fulfillment/nonkomship/:id',
    name: 'kompack-total-nilai-transaksi-fulfillment-nonkomship-detail',
    component: () => import('@/views/pages/kompack/dashboard/total-nilai-transaksi/fulfillment/nonkomship/FulfillmentNonKomshipDetail.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack - Dashboard',
      action: 'manage',
    },
  },
  {
    path: '/kompack/total-nilai-transaksi/fulfillment/marketplace/:id',
    name: 'kompack-total-nilai-transaksi-fulfillment-marketplace-detail',
    component: () => import('@/views/pages/kompack/dashboard/total-nilai-transaksi/fulfillment/marketplace/Page.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack - Dashboard',
      action: 'manage',
    },
  },
  {
    path: '/kompack/total-nilai-transaksi/penarikan/:id',
    name: 'kompack-total-nilai-transaksi-penarikan-detail',
    component: () => import('@/views/pages/kompack/dashboard/total-nilai-transaksi/penarikan/PenarikanDetail.vue'),
    meta: {
      navActiveLink: 'admin-dashboard-kompack',
      resource: 'Kompack - Dashboard',
      action: 'manage',
    },
  },
]
